import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'filterArrayOfObjects',
})
export class FilterArrayOfObjectsPipe implements PipeTransform {
  transform(
    array: { [key: string]: any }[],
    filterText: string,
    attribute: string
  ): { [key: string]: any }[] {
    if (!this.isValid(array, filterText, attribute)) {
      return array;
    }

    return array.filter(
      item =>
        item[attribute] &&
        item[attribute]
          .toLocaleLowerCase()
          .includes(filterText.toLocaleLowerCase())
    );
  }

  isValid(
    array: { [key: string]: any }[],
    filterText: string,
    attribute: string
  ) {
    return !(!filterText || !attribute || isEmpty(array));
  }
}
